// parseDropdownData.js

/**
 * Parses the nested dropdown data and returns five arrays:
 * companies, teams, departments, divisions, and positions.
 *
 * Each array contains objects with the shape: { id: number, name: string }.
 *
 * @param {Object} data - The nested data object (keyed by company name).
 * @returns {Object} - An object with arrays for each entity type.
 */
export const parseDropdownData = (data) => {
    const companiesMap = new Map();
    const teamsMap = new Map();
    const departmentsMap = new Map();
    const divisionsMap = new Map();
    const positionsMap = new Map();
  
    Object.keys(data).forEach((companyName) => {
      const company = data[companyName];
      companiesMap.set(company.id, { id: company.id, name: companyName });
  
      company.teams.forEach((team) => {
        teamsMap.set(team.id, { id: team.id, name: team.name });
      });
  
      company.departments.forEach((department) => {
        departmentsMap.set(department.id, { id: department.id, name: department.name });
  
        department.divisions.forEach((division) => {
          divisionsMap.set(division.id, { id: division.id, name: division.name });
  
          division.positions.forEach((position) => {
            positionsMap.set(position.id, { id: position.id, name: position.name });
          });
        });
      });
    });
  
    return {
      companies: Array.from(companiesMap.values()),
      teams: Array.from(teamsMap.values()),
      departments: Array.from(departmentsMap.values()),
      divisions: Array.from(divisionsMap.values()),
      positions: Array.from(positionsMap.values()),
    };
  };
  